import { render, staticRenderFns } from "./SecTable.vue?vue&type=template&id=20e39c74&"
import script from "./SecTable.vue?vue&type=script&lang=js&"
export * from "./SecTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports